/* eslint-disable no-console */
import axios from 'axios'

import getLocaleParam from 'Pods/Shared/Utils/getLocaleParam'

const transformTrendingItem = (item) => {
  const attributes = item?.attributes
  const price = attributes.price
  const saleOffDiscount = attributes.saleOffDiscount || 0
  const finalPrice = saleOffDiscount ? price * (100 - saleOffDiscount) / 100.0 : price
  const primaryImage = attributes.primaryImage?.gridUrl || attributes.primaryImage?.gridFallbackUrl

  return {
    id: Number(item.id),
    primaryImage,
    title: attributes.title,
    price,
    finalPrice,
    formats: attributes.formats || [],
    slug: attributes.url || '',
    percentage: saleOffDiscount,
  }
}

export const newHomepageService = {
  async getTrendingModels(perPage = 10) {
    try {
      const response = await axios.get(`/3d-models/trending.json?per_page=${perPage}`)
      const items = response?.data?.data || []

      return items.map(transformTrendingItem)
    } catch (error) {
      console.error('Error fetching trending models:', error)
      window.Sentry.captureException('Error fetching trending models:', error)
      throw error
    }
  },

  async getPrintTrendingModels(perPage = 8) {
    try {
      const response = await axios.get(`/3d-print-models/trending.json?per_page=${perPage}`)
      const items = response?.data?.data || []

      return items.map(transformTrendingItem)
    } catch (error) {
      console.error('Error fetching trending models:', error)
      window.Sentry.captureException('Error fetching trending models:', error)
      throw error
    }
  },

  async getFeaturedDesigner() {
    try {
      const locale = getLocaleParam()
      const config = locale ? { params: { locale } } : {}
      const response = await axios.get('/api/internal/featured_designers', config)
      return response?.data
    } catch (error) {
      console.error('Error fetching featured designer:', error)
      window.Sentry.captureException('Error fetching featured designer:', error)
      throw error
    }
  },
}
